var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('div',{staticClass:"important-text error"},[_c('div',[_vm._v("\n        Възникна грешка, моля свържете се с поддръжка!\n        "),_c('br'),_vm._v("\n        info@articket.eu\n      ")]),_vm._v(" "),_c('div',[_vm._v("Error, please contact support!")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }